import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { ElementType } from '~/modules/analytics/gtmEventTypes/constants';
import { getAppCost, getAppType, getQueryStringValue } from '~/modules/analytics/gtmEventTypes/gtmEventTypeHelper';
import {
    GtmListingDetailClickType,
    ListingDetailsClickAnalyticsEvent,
} from '~/modules/analytics/gtmEventTypes/gtmListingDetailClickType';
import { GA4CarouselClickEvent, GA4ListingDetailClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';

export enum CarouselIconAction {
    BACK = 'back',
    NEXT = 'next',
    CLOSE = 'close',
}

export type CarouselClickAnalyticsEvent = {
    label: CarouselIconAction;
    navItem: string;
    url: string;
    level: string;
    pricing: string;
    sponsoredCampaign: string;
    recommended: boolean;
    oafId: string;
    title: string;
    listingRecordType: string;
} & GTMBaseEvent;

export class GtmCarouselClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === ElementType.CAROUSEL;
    }

    override getBody(
        event: CarouselClickAnalyticsEvent | ListingDetailsClickAnalyticsEvent,
    ): GA4CarouselClickEvent | GA4ListingDetailClickEvent {
        const label = (event as CarouselClickAnalyticsEvent).label;
        if (label && [CarouselIconAction.BACK, CarouselIconAction.CLOSE, CarouselIconAction.NEXT].includes(label)) {
            const { url, pricing, recommended, sponsoredCampaign, oafId, title, listingRecordType } =
                event as CarouselClickAnalyticsEvent;
            return {
                event: 'custEv_appEngagement',
                click_text: label,
                click_url: url,
                element_type: ElementType.CAROUSEL,
                lp_detail_interaction: true,
                app_cost: getAppCost(pricing),
                app_type: getAppType(listingRecordType),
                featured: !!sponsoredCampaign,
                recommended: recommended,
                ignore_hover: false,
                internal_article: false,
                hover_intent: false,
                internal_source: getQueryStringValue(url, 'channel'),
                listing_id: oafId,
                listing_name: title,
                listing_type: listingRecordType,
                listing_url: url,
                page_type: 'listing details',
            };
        }

        const {
            clickUrl,
            pricing,
            listingRecordType,
            sponsoredCampaign,
            recommended,
            oafId,
            title,
            url,
            button,
            link,
        } = event as ListingDetailsClickAnalyticsEvent;
        const elementClickUrl = clickUrl || link?.callToAction?.url || url;

        return {
            event: 'custEv_appEngagement',
            click_text:
                button?.callToAction?.name ||
                button?.callToAction?.label ||
                link?.callToAction?.name ||
                link?.callToAction?.label ||
                event.caption,
            click_url: elementClickUrl,
            element_title: GtmListingDetailClickType.getItemTitle(event),
            element_type: GtmListingDetailClickType.getElementType(event),
            internal_driver: getQueryStringValue(elementClickUrl, 'd'),
            lp_detail_interaction: true,
            app_cost: getAppCost(pricing),
            app_type: getAppType(listingRecordType),
            featured: !!sponsoredCampaign,
            recommended: recommended,
            ignore_hover: false,
            internal_article: false,
            internal_source: getQueryStringValue(elementClickUrl, 'channel'),
            listing_id: oafId,
            listing_name: title,
            listing_type: listingRecordType,
            listing_url: url,
            hover_intent: false,
            page_type: 'listing details',
        };
    }
}
